import * as AccordionPrimitive from "@radix-ui/react-accordion"
import * as React from "react"

import { Minus } from "../components"
import { cn } from "./util"

const AccordionRoot = AccordionPrimitive.Root

const AccordionItem = AccordionPrimitive.Item

const AccordionTrigger = React.forwardRef<
    React.ElementRef<typeof AccordionPrimitive.Trigger>,
    React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger>
>(({ className, children, ...props }, ref) => (
    <AccordionPrimitive.Header asChild>
        <div className="flex">
            <AccordionPrimitive.Trigger
                ref={ref}
                className={cn(
                    "flex flex-1 items-center justify-between text-left text-sm transition-all [&[data-state=open]>svg]:rotate-180",
                    className
                )}
                {...props}>
                {children}
                <svg
                    className="ml-2 shrink-0 transition-transform duration-200"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none">
                    <path
                        d="M18 10L12.7071 15.2929C12.3166 15.6834 11.6834 15.6834 11.2929 15.2929L6 10"
                        stroke="currentColor"
                        strokeLinecap="round"
                    />
                </svg>
            </AccordionPrimitive.Trigger>
        </div>
    </AccordionPrimitive.Header>
))
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName

const AccordionContent = React.forwardRef<
    React.ElementRef<typeof AccordionPrimitive.Content>,
    React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Content>
>(({ className, children, ...props }, ref) => (
    <AccordionPrimitive.Content
        ref={ref}
        className="overflow-hidden data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
        {...props}>
        <div className={cn("pt-3", className)}>{children}</div>
    </AccordionPrimitive.Content>
))

AccordionContent.displayName = AccordionPrimitive.Content.displayName
const AccordionTriggerWithPlus = React.forwardRef<
    React.ElementRef<typeof AccordionPrimitive.Trigger>,
    React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger>
>(({ className, children, ...props }, ref) => (
    <AccordionPrimitive.Header asChild>
        <div className="flex">
            <AccordionPrimitive.Trigger
                ref={ref}
                className={cn(
                    "group flex flex-1 items-center justify-between text-left text-sm transition-all",
                    className
                )}
                {...props}>
                {children}
                <span className="relative h-6 w-6">
                    <Minus className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" />
                    <Minus className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rotate-90 transition-transform duration-200 group-data-[state=open]:rotate-180" />
                </span>
            </AccordionPrimitive.Trigger>
        </div>
    </AccordionPrimitive.Header>
))
AccordionTriggerWithPlus.displayName = AccordionPrimitive.Trigger.displayName

export { AccordionContent, AccordionItem, AccordionRoot, AccordionTrigger, AccordionTriggerWithPlus }
